// TODO: Use types from here in ProfileEdit.vue

// State
export const STATE_USER = "users/STATE_USER";
export const STATE_IS_USER_LOGGED_IN = "users/STATE_IS_USER_LOGGED_IN";
export const STATE_USER_RECENTITEMS = "users/STATE_USER_RECENTITEMS";
export const STATE_NOTIFICATIONS = "users/STATE_NOTIFICATIONS";
export const STATE_NOTIFICATION_SHOWN = "users/STATE_NOTIFICATION_SHOWN";
export const STATE_IS_NOTIFICATION_SHOWN = "users/STATE_IS_NOTIFICATION_SHOWN";
export const STATE_LASTNOTIFICATIONID = "users/STATE_LASTNOTIFICATIONID";

// Getters
export const GET_USER_DATA = "users/GET_USER_DATA";
export const GET_IS_USER_LOGGED_IN = "users/GET_IS_USER_LOGGED_IN";
export const GET_USER_RECENTITEMS = "users/GET_USER_RECENTITEMS";
export const GET_NOTIFICATIONS = "users/GET_NOTIFICATIONS";
export const GET_NOTIFICATION_SHOWN = "users/GET_NOTIFICATION_SHOWN";
export const GET_IS_NOTIFICATION_SHOWN = "users/GET_IS_NOTIFICATION_SHOWN";
export const GET_LASTNOTIFICATIONID = "users/GET_LASTNOTIFICATIONID";

// Mutations
export const MUTATE_SET_USER_DATA = "users/MUTATE_SET_USER_DATA";
export const MUTATE_CLEAR_USER_DATA = "users/MUTATE_CLEAR_USER_DATA";
export const MUTATE_SET_IS_USER_LOGGED_IN = "users/MUTATE_SET_IS_USER_LOGGED_IN";
export const MUTATE_SET_USER_RECENTITEMS = "users/MUTATE_SET_USER_RECENTITEMS";
export const MUTATE_SET_NOTIFICATIONS = "users/MUTATE_SET_USER_NOTIFICATIONS";
export const MUTATE_ADD_NOTIFICATIONS = "users/MUTATE_ADD_NOTIFICATIONS";
export const MUTATE_SET_LASTNOTIFICATIONID = "users/MUTATE_SET_USER_LASTNOTIFICATIONID";
export const MUTATE_SET_NOTIFICATION_SHOWN = "users/MUTATE_SET_NOTIFICATION_SHOWN";
export const MUTATE_SET_IS_NOTIFICATION_SHOWN = "users/MUTATE_SET_IS_NOTIFICATION_SHOWN";

// Actions
export const ACTION_AUTHENTICATE_CREDENTIALS = "users/ACTION_AUTHENTICATE_CREDENTIALS";
export const ACTION_CHECK_IS_USER_LOGGED_IN = "users/ACTION_CHECK_IS_USER_LOGGED_IN";
export const ACTION_LOGOUT_USER = "users/ACTION_LOGOUT_USER";
export const ACTION_GET_USER = "users/ACTION_GET_USER";
export const ACTION_UPDATE_USER = "users/ACTION_UPDATE_USER";
export const ACTION_GET_USER_RECENTITEMS = "users/ACTION_GET_USER_RECENTITEMS";
export const ACTION_INIT_NOTIFICATIONS = "users/ACTION_INIT_NOTIFICATIONS";
export const ACTION_GET_NOTIFICATIONS = "users/ACTION_GET_NOTIFICATIONS";
export const ACTION_SHOW_NOTIFICATION = "users/ACTION_SHOW_NOTIFICATION";